import { SectionId, SectionShowView } from '../types/sections';
import { MainV3ApiBase } from './base';

export const SectionApis = {
  base() {
    return MainV3ApiBase.appendPath('sections');
  },
  show(sectionId: SectionId): Promise<SectionShowView> {
    return this.base().withId(sectionId).get();
  },
};
